// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__jY5uS","colCheckbox":"styles_colCheckbox__xHNIF"};